export default __webpack_public_path__ + "static/media/Katze-auf-Ball.7268f194.png";